/* Response Time CSS */

export default theme => ({
    root: {},
    chart: {
      width: '500px',
      margin: '0 auto',
      //height: '300px',
      textAlign: 'center',
    },
    backGrey:{
      backgroundColor:"#676767",
      width:"820px"
    },
    backWhite:{
      backgroundColor:"white",
      fontSize: "bold",
      font:"Roboto", 
      color:"white"
    },
    textWhite:{
      color:"white",
      fill:"white",
      fontSize: "bold",
    },
    header: {
      height: '40px',
      color: theme.palette.text.secondary
    },
    portletFooter: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    details: {
      
      padding: '50px',
      flex: '1 100%',
      marginTop: '50px',
      marginBottom: '50px',
      marginRight: '50px',
      marginLeft: '50px'
    },
    har:{
      width:"100%",
      backgroundColor:"white",
      "& div":{ width:"100%"}
    }
  
  })